import Datagent from "datagent";
import {respondData,requestHandle,List,isDef} from "../utils";
import { getURL } from 'datagent/src/utils';

const isNew = data => !isDef(data.id) || !data.id
const {filter, format, getField, awaitTo} = Datagent.Hooks;

import Fecha from '../utils/type/Fecha';
import {defaults} from "datagent/src/utils";

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const map = ()=> ctx => {
  ctx.result = ctx.result.map(i=>{
    const keysHash = {
      'id': 'id',
      'firstTargetNum': 'id',
      'secondTargetNum': 'id',
      'thirdTargetNum': 'id',
      'firstTargetName': 'name',
      'secondTargetName': 'name',
      'thirdTargetName': 'name',
      'dimension': 'name',
    }
    const result = {}

    Object.keys(i).map(key=>{ result[keysHash[key]]=i[key] })

    return result
  })
  return ctx
}

const name = "listedTarget";
const Model = Datagent.Model({
    name,
    fields: {
      'id'                 : {type: String, default: null},
      'firstTargetName'    : {type: String, default:''}, //一级指标
      'firstTargetNum'     : {type: String, default: ''}, // 一级指标编码
      'secondTargetName'   : { type: String, default: ''}, //二级指标
      'secondTargetNum'    : {type: String, default: ''}, // 二级指标编码
      'thirdTargetName'   : { type: String, default: ''}, //三级指标
      'thirdTargetNum'    : {type: String, default: ''}, // 三级指标编码
      'targetType'         : {type: Number, default: 0}, //指标分类0-舆情；1-青悦；2-预警通
      'keyword'            : {type: String, default: ''}, // 关键词
      'dimensionInfo'      : {type: Array, default: []}, //维度信息
    },
    methods: {
        fetch(params, opts){
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/list`, { ...params });
        },
        search(params, opts){
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/list`, { allTab:1, ...params });
        },
        SaveKeyword(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).put(`${this._url}/keyword`, { ...params });
        },
        firstTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/firstTarget`, {...params})
        },
        secondTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/secondTarget`, {...params})
        },
        thirdTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/thirdTarget/list`, {...params})
        },
        getThirdTarget(params, opts) { //查询单个三级指标
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/thirdTarget`, {...params})
        },
        dimension(params, opts) {
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/dimension`, {...params})
        },
        dimensionRule(params, opts) {
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/dimensionRule`, {...params})
        },
        createSecondTargetNum(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/secondTarget/newNum`, {...params})
        },
        save(data, opts) {
            const { origin } = defaults(opts);
            const { id, type } = data;
            const url = getURL(this._url+'/thirdTarget', id, this._emulateIdKey);
            return this.remote(origin)[isNew(data) ? 'post' : 'put'](url, data);
        },
        destroy(params, opts) {
            const { origin } = defaults(opts);
            const { thirdTargetNum ,...data } = params
            const url = getURL(this._url, thirdTargetNum, this._emulateIdKey);
            return this.remote(origin).delete(`${this._url}/thirdTarget`, { ...data, thirdTargetNum, isDelete: 1 });
        },
        export(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/list/export`, params)
        },
    },
    hooks: {
        fetch: { after: [respondData(), requestHandle(), getField("data", format())] },
        find: { after: [respondData(), requestHandle(), format()] },
        firstTarget: { after: [respondData(), requestHandle(), getField('data', map())] },
        secondTarget: { after: [respondData(), requestHandle(), getField('data', map())] },
        thirdTarget: { after: [respondData(), requestHandle(), getField('data', map())] },
        dimension: { after: [respondData(), requestHandle(), getField('data', map())] },
        dimensionRule: { after: [respondData(), requestHandle()] },
        createSecondTargetNum: { after: [respondData(), requestHandle()] },
        getThirdTarget: { after: [respondData(), requestHandle(), getField('data', format())] },
        search: { after: [respondData(), requestHandle(), getField('data', format())] },
        destroy: { after: [respondData(), requestHandle()] },
        save: { before:[format()], after: [respondData(), requestHandle()] },
        export: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
Model.validation = function () {
    return {
      firstTargetNum: [
        { required: true, type: 'string', message: '请选择一级指标', trigger: 'change' }
      ],
      secondTargetNum: [
        { required: true, type: 'string', message: '请选择二级指标', trigger: 'change' }
      ],
      thirdTargetName: [
        { required: true, type: 'string', message: '请填写指标名称', trigger: 'change' }
      ],
      targetType: [
        { required: true, type: 'number', message: '请选择指标类型', trigger: 'change' }
      ],
      dimensionInfo: [
        { required: true, type: 'array', message: '请添加评分维度', trigger: 'change' }
      ],
    }
};
export default Model;
